import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {FireService} from './fire.service';
import {AppState} from '../models/AppState';
import {AppStateService} from './app-state.service';
import {PaymentSession} from '../models/payment-session';

@Injectable({
  providedIn: 'root'
})
export class PaymentSessionService implements OnDestroy {

  private sub1?: Subscription;
  private sub2?: Subscription;
  private paymentSessionSubject = new BehaviorSubject<PaymentSession | null>(null);

  constructor(private fireService: FireService, private appStateService: AppStateService) {}

  ngOnDestroy(): void {
    this.sub1?.unsubscribe();
    this.sub2?.unsubscribe();
  }

  private initService() {
    this.sub1 = this.appStateService.observeAppState().subscribe(appState => {
      this.initPaymentSessionObserver(appState);
    });
  }

  private initPaymentSessionObserver(appState: AppState) {
    const table = appState.order?.user_cfg?.table
    if (table != null) {
      this.sub2?.unsubscribe();
      this.sub2 = this.fireService.observePaymentSession(table, appState.venueId).subscribe(session => {
        console.log("Payment session", session);
        if (session != null) {
          // if activated date is not null and time is less than 10 minutes ago, use moment lib
          if ( session.livesplit_activated_date != null ) {
            const now = new Date();
            const tenMinutesAgo = new Date(now.getTime() - 10*60000);
            session.isLivesplitActive = session.livesplit_activated_date.toDate() > tenMinutesAgo;
          }

          const myUserId = appState?.order?.user_cfg?.user_id?.toString() ?? "";
          for (const amount of session.amounts || []) {
            if (amount.user_id === myUserId) {
              session.hasOwnItemsToPay = amount.amount > 0;
            } else if (amount.user_id.includes("-")) {
              session.tableItemsToPay = true;
            } else {
              session.hasOtherItemsToPay = true;
            }
          }

          session.payableItems = session.hasOwnItemsToPay || session.tableItemsToPay || (session.isLivesplitActive && session.hasOtherItemsToPay);
        }
        this.paymentSessionSubject.next(session);
      });
    } else {
      this.paymentSessionSubject.next(null);
    }
  }

  observePaymentSession(): Observable<PaymentSession | null> {
    if (this.sub1 == null) {
      this.initService();
    }
    return this.paymentSessionSubject.asObservable();
  }

}
